import { useAcsFetch } from '../hooks/use-acs-fetch'
import {
  Beneficiary,
  CommunityPropertyState,
  DeleteIraBenePayload,
  FetchIraBeneResponse,
  IraBeneResponse,
  IraPlan,
} from '../types'

export interface UpdateOptions {
  accountNickname?: string
}
// TO DO- confirm that these types are in line with api
export const useIraBeneficiariesApi = (): {
  fetchIraBeneficiaries: () => Promise<IraPlan[]>
  createIraBeneficiary: (
    accountId: string,
    payload: Beneficiary,
  ) => Promise<IraBeneResponse>
  updateIraBeneficiary: (
    accountId: string,
    payload: Beneficiary,
  ) => Promise<IraBeneResponse>
  deleteIraBeneficiary: (payload: DeleteIraBenePayload) => Promise<any>
  fetchCommunityPropertyState: () => Promise<CommunityPropertyState>
} => {
  const acsFetch = useAcsFetch({
    withCif: true,
    withGuid: true,
    defaultHeaders: {
      ApplicationVersion: '2.9',
      ApplicationID: 'ALLYUSBOLB',
      ApplicationName: 'AOB',
    },
  })

  const fetchIraBeneficiaries = async (): Promise<IraPlan[]> => {
    const result = await acsFetch<FetchIraBeneResponse>(
      `/v1/bank-accounts/beneficiary/iraplans/beneficiaries`,
    )

    if (result.data.iraPlans) {
      return result.data.iraPlans
    }

    throw new Error('No beneficiary payload in successful response')
  }

  // TO DO- update urls
  const createIraBeneficiary = async (
    accountId: string,
    payload: any,
  ): Promise<any> => {
    const result = await acsFetch<Record<string, any>>(
      `/v1/bank-accounts/beneficiary/iraplans/${accountId}/beneficiaries`,
      { method: 'POST', body: JSON.stringify(payload) },
    )

    if (result.data) {
      return result.data as any
    }

    throw new Error('No beneficiary payload in successful response')
  }

  const updateIraBeneficiary = async (
    accountId: string,
    payload: any,
  ): Promise<any> => {
    const result = await acsFetch<Record<string, any>>(
      `/v1/bank-accounts/beneficiary/iraplans/${accountId}/beneficiaries`,
      {
        method: 'PATCH',
        body: JSON.stringify(payload),
      },
    )
    if (result.data) {
      return result.data as any
    }

    throw new Error('No beneficiaries payload in successful response')
  }

  const deleteIraBeneficiary = async (
    payload: DeleteIraBenePayload,
  ): Promise<{ data: null }> => {
    const result = await acsFetch<{ data: null }>(
      `/v1/bank-accounts/beneficiary/iraplans/${payload.planId}/beneficiaries/${payload.beneficiaryId}`,
      {
        method: 'DELETE',
      },
    )
    return result.data
  }

  const fetchCommunityPropertyState =
    async (): Promise<CommunityPropertyState> => {
      const result = await acsFetch<CommunityPropertyState>(
        `/v1/bank-accounts/beneficiary/communitypropertystate`,
      )

      if (result.data) {
        return result.data
      }

      throw new Error(
        'No community property state payload in successful response',
      )
    }

  return {
    fetchIraBeneficiaries,
    createIraBeneficiary,
    updateIraBeneficiary,
    deleteIraBeneficiary,
    fetchCommunityPropertyState,
  }
}
